const createAlertSlice = (set, get) => ({
  alert: {
    message: '',
    show: false,
  },
});

export default createAlertSlice;
